import React from 'react'
import { FiUploadCloud } from 'react-icons/fi'

interface ImageWrapperProps {
  url: string
  removeHandler: () => void
  editMode?: boolean
  imageContainerClass?: string
}

const ImageWrapper: React.FC<ImageWrapperProps> = ({
  url,
  removeHandler,
  editMode,
  imageContainerClass,
}) => {
  const [error, setError] = React.useState(false)

  return (
    <div>
      {error || !url ? (
        <div
          className={`${imageContainerClass} bg-[#f8f8f8] rounded-lg flex items-center justify-center overflow-hidden`}
        >
          <div className="flex flex-col items-center justify-center h-full w-full">
            <div className="mb-1">
              <FiUploadCloud className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-gray-800" />
            </div>
            <div className="flex flex-col items-center text-center text-SeabiscuitDark200ThemeColor text-xs  font-normal">
              <p>Upload</p>
              <p>Document</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="relative w-full h-full flex items-center justify-center">
          <div
            className={`${imageContainerClass} rounded-lg overflow-hidden border-2 border-[#f1f2f2] shadow-sm`}
          >
            <img
              className="w-full h-full object-cover cursor-pointer hover:opacity-85"
              onError={() => setError(true)}
              alt={'Membership document'}
              onClick={() => window.open(url, '_blank')}
              src={url}
            />
          </div>
          {editMode && (
            <div
              className="absolute inset-0 bg-gray-900 bg-opacity-40 rounded-lg flex items-center justify-center cursor-pointer"
              onClick={removeHandler}
            >
              <div className="w-16 h-16 flex items-center justify-center">
                <img src="/assets/cp_icons/Close-white.svg" alt="Remove" className="w-8 h-8" />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ImageWrapper
